const precisionForZeroBalance = (availableBalance, commaSeperatedValue, precision) => {
  return Number(commaSeperatedValue) === 0 && availableBalance > 0
    ? `~${(0).toFixed(precision)}`
    : commaSeperatedValue;
};

function getValidBalance(balance: string | number) {
  return Number.isNaN(Number(balance)) ? 0 : Number(balance);
}

export { precisionForZeroBalance, getValidBalance };
